import PropTypes from 'prop-types'
import React from 'react'

import Link from 'base/react/components/link'
import NotificationProvider from 'base/containers/notifications/provider'
import NotificationList from 'base/components/notifications/list'

let links = [
  {
    key: 'info',
    title: 'Account',
    url: '/account/info',
  },
  {
    key: 'orders',
    title: 'Orders & Returns',
    url: '/account/orders',
  },
  {
    key: 'redeem',
    title: 'Redeem a Gift Card',
    url: '/redeem',
  },
]

function AccountDropdown({ onRequestLogOut, showAdminLink, onClick, hideReferralLink }) {
  if (hideReferralLink) {
    links = links.filter(link => link.key !== 'invite')
  }

  const items = links.map(link => {
    return (
      <li key={link.url} className="account-dropdown__item">
        <Link href={link.url} onClick={() => onClick(link.key)}>
          {link.title}
        </Link>
      </li>
    )
  })

  if (showAdminLink) {
    items.unshift(
      <li key="admin" className="account-dropdown__item">
        <Link href="/admin" target="_blank">
          <span className="account-dropdown__admin-link">Go to Admin Site</span>
        </Link>
      </li>,
    )
  }

  items.push(
    <li key="logout" className="account-dropdown__item">
      <Link onClick={onRequestLogOut}>Log Out</Link>
    </li>,
  )

  return (
    <div className="account-dropdown">
      <h1 className="account-dropdown__header">Your Account</h1>
      <hr />

      <NotificationProvider>
        <NotificationList />
      </NotificationProvider>

      <ul className="account-dropdown__links">{items}</ul>
    </div>
  )
}

AccountDropdown.propTypes = {
  onRequestLogOut: PropTypes.func.isRequired,
  showAdminLink: PropTypes.bool.isRequired,
  hideReferralLink: PropTypes.bool,
}

export default AccountDropdown
